import * as React from 'react'

import { LoyaltyDisplayIcon } from '@toasttab/buffet-pui-icons'

import { Banner } from '../Banner'
import { getAvailabilitySummary } from '../utils'

import { LoyaltyBanner as LoyaltyBannerType } from '../@types'

type LoyaltyBannerProps = {
  banner: LoyaltyBannerType
  testId: string
}

export const LoyaltyBanner = ({ banner, testId }: LoyaltyBannerProps) => (
  <Banner testId={testId}>
    <Banner.BannerIcon>
      <LoyaltyDisplayIcon testId='loyalty-banner-icon' size='md' />
    </Banner.BannerIcon>
    <Banner.BannerText>
      <Banner.BannerTitle>{banner.bannerText}</Banner.BannerTitle>
      <Banner.BannerDescription>
        {getAvailabilitySummary(banner.availability)}
      </Banner.BannerDescription>
    </Banner.BannerText>
  </Banner>
)
